import PropTypes from 'prop-types';
import React from 'react';
import { loadTreatment } from '@surfline/web-common/dist/features/redux';
import { useDispatch } from 'react-redux';
import en from '../../intl/translations/en';
import { SL_WEB_MOBILE_FORECAST_PAYWALL } from '../../common/treatments';

const ChartRangeSelectorCTA = ({ href, onClickPaywall, mobile }) => {
  const dispatch = useDispatch();

  const button = (
    <div className="sl-chart-range-selector-cta__action">
      <a href={href} onClick={onClickPaywall} className="sl-chart-range-selector-cta__action__link">
        {en.premiumCTA.ChartRangeSelectorCTA.linkText}
      </a>
    </div>
  );

  const text = (
    <div className="sl-chart-range-selector-cta__text">
      {en.premiumCTA.ChartRangeSelectorCTA.mainText}
    </div>
  );

  let rangeSelectorCTA = (
    <div className="sl-chart-range-selector-cta">
      {text}
      {button}
    </div>
  );

  if (mobile) {
    const mobileTreatment = dispatch(loadTreatment(SL_WEB_MOBILE_FORECAST_PAYWALL));
    if (mobileTreatment === 'Variant_1') {
      rangeSelectorCTA = (
        <div className="sl-chart-range-selector-cta sl-chart-range-selector-cta--variant-1">
          {button}
          {text}
        </div>
      );
    } else if (mobileTreatment === 'Variant_2') {
      rangeSelectorCTA = (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div
          className="sl-chart-range-selector-cta sl-chart-range-selector-cta--variant-2"
          onClick={() => {
            onClickPaywall();
            if (window) window.location.href = href;
          }}
        >
          {button}
          {text}
        </div>
      );
    } else {
      rangeSelectorCTA = (
        <div className="sl-chart-range-selector-cta">
          {text}
          {button}
        </div>
      );
    }
  }

  return rangeSelectorCTA;
};

ChartRangeSelectorCTA.defaultProps = {
  onClickPaywall: null,
  href: null,
  mobile: false,
};

ChartRangeSelectorCTA.propTypes = {
  onClickPaywall: PropTypes.func,
  href: PropTypes.string,
  mobile: PropTypes.bool,
};

export default ChartRangeSelectorCTA;
